import styled from "styled-components";
import { breakpoints, grid } from "root/libs/ui-styleguide/src";

export const ScrollFlexWrapper = styled.div`
  display: flex;
  padding-top: 0;
  padding-bottom: var(--dui-size-space-5x);
  padding-left: var(--gaq-size-space-3px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-color: transparent transparent;
    -webkit-overflow-scrolling: touch;
  }

  ::-webkit-scrollbar {
    background: transparent;
    display: none;
  }
`;

export const PresetSizeCardGroupWrapper = styled.div`
  flex: 0 0 auto;
  padding: var(--dui-size-space-2x) ${grid.columns.width.s}
    var(--dui-size-space-9x) ${grid.columns.width.s};
  flex-wrap: wrap;
  && {
    width: 100%;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-left: 0;
    flex-wrap: inherit;
    width: inherit;
    padding: var(--dui-size-space-2x) 0;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-right: 0;
    flex: unset;
    padding: 0;
  }
`;

export const GradientWrapper = styled.div`
  position: relative;
  width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}) {
    &::after {
      content: "";
      position: absolute;
      height: 100%;
      top: 0;
      right: 0;
      pointer-events: none;
      z-index: 1;
      width: 80px;
      background-image: linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 1) 60%,
        rgba(255, 255, 255, 1)
      );
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    &::after {
      display: none;
    }
  }

  @media print {
    display: none;
  }
`;
